import resume from './resume'

export default {
  resume,
}
